import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { LIVE_DOMAIN } from './constants';

const DEFAULT_BRAND_NAME = 'Platform';

const normaliseUrl = (url?: string | null) => {
    if (!url || typeof url !== 'string') return '';

    const trimmedUrl = url.trim().replace(/\/+$/, '');
    if (!trimmedUrl) return '';

    return /^https?:\/\//i.test(trimmedUrl)
        ? trimmedUrl
        : `https://${trimmedUrl}`;
};

export const getTenantBrandName = (client?: any) =>
    client?.name || client?.general_title || DEFAULT_BRAND_NAME;

export const getTenantPublicUrl = (client?: any) => {
    return normaliseUrl(client?.url) || normaliseUrl(LIVE_DOMAIN);
};

export const buildTenantUserUrl = (client: any, userName?: string | null) => {
    const publicUrl = getTenantPublicUrl(client);

    if (!publicUrl || !userName) return '';

    return `${publicUrl}/${userName}`;
};

export const buildTenantListingUrl = (
    client: any,
    section: string,
    categoryName?: string,
    postId?: string | number
) => {
    const publicUrl = getTenantPublicUrl(client);

    if (!publicUrl || !categoryName || !postId) return '';

    return `${publicUrl}${section}/${categoryName}/${postId}`;
};

export const useTenant = () => {
    const profile =
        useSelector((store: RootState) => store?.commonAppData?.profile) || {};
    const client = profile?.client || {};

    return {
        client,
        brandName: getTenantBrandName(client),
        publicUrl: getTenantPublicUrl(client),
        getUserUrl: (userName?: string | null) =>
            buildTenantUserUrl(client, userName),
        getListingUrl: (
            section: string,
            categoryName?: string,
            postId?: string | number
        ) => buildTenantListingUrl(client, section, categoryName, postId)
    };
};
